import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTheme } from '@emotion/react'

// config
import { Path } from '@/config'
// hooks
import { useAppSelector, useAppDispatch, useUserPublic } from '@/hooks'
// icons
import { icons } from '@/assets'
// features
import {
  unlockSelectUnlockTrackModalTrack,
  unlockCloseUnlockTrackModal,
} from '@/features'
// components
import { CardHeaderMobile, ModalCardTitle, ModalCardSubtitle, Error } from '@/components'

// components
import { UnlockTrackForm } from './components'
// styles
import { styles } from './styles'

type UnlockTrackCardProps = {}

export const UnlockTrackCard: FC<UnlockTrackCardProps> = () => {
  const theme = useTheme()
  const navigate = useNavigate()

  const dispatch = useAppDispatch()
  const modalTrack = useAppSelector(unlockSelectUnlockTrackModalTrack)
  const unlockTrackError = ''

  const { userId: authorUserId } = modalTrack ?? {}

  // track author
  const { user: trackAuthor, isLoading: isTrackAuthorLoading } = useUserPublic(
    authorUserId || '',
  )
  const { username: authorUsername } = trackAuthor ?? {}
  const authorLoadingPlaceholder = 'Loading...'
  const authorUsernamePlaceholder = 'unknown'

  const subtitleAccentStartIndex = 52
  const subtitleAccentEndIndex =
    53 +
    (authorUsername?.length ||
      authorLoadingPlaceholder.length ||
      authorUsernamePlaceholder.length)

  return (
    <div
      css={styles(theme).card.main}
      onClick={(e) => e.stopPropagation()}
      aria-hidden="true"
    >
      {/* mobile header */}
      <div css={styles(theme).card.header}>
        <CardHeaderMobile onCloseClick={() => dispatch(unlockCloseUnlockTrackModal())} />
      </div>

      {/* title */}
      <div css={styles(theme).card.title}>
        <ModalCardTitle text="Unlock Track" icon={icons.Unlock} />
      </div>

      {/* subtitle */}
      <div css={styles(theme).card.subtitle}>
        <ModalCardSubtitle
          text={`Access premium content and express your support for @${
            isTrackAuthorLoading
              ? authorLoadingPlaceholder
              : authorUsername || authorUsernamePlaceholder
          } by unlocking exclusive track.`}
          accent={{
            accentStart: subtitleAccentStartIndex,
            accentEnd: subtitleAccentEndIndex,
            onClick: () => navigate(`${Path.User}/${authorUserId}`),
          }}
        />
      </div>

      <div css={styles(theme).card.content.main}>
        {/* form */}
        <div css={styles(theme).card.content.form}>
          <UnlockTrackForm />
        </div>

        <div css={styles(theme).card.content.error}>
          <Error error={unlockTrackError} />
        </div>
      </div>
    </div>
  )
}

UnlockTrackCard.propTypes = {}
